import React from 'react'
import Score, { StarIcon, ScoreText, } from '../styles/score'
import starIcon from '../assets/icons/star.svg'
import { getPersianNumber } from '../utils/number'

export default ({ children, status }) => (
  <Score className={status}>
    <StarIcon alt="*" src={starIcon} />
    <ScoreText>{getPersianNumber(children)}</ScoreText>
  </Score>
)
